import NavBar from "@/view/components/nav-bar/nav-bar";
import { ref } from "@vue/reactivity";
import SessionUtil from "../../../utils/SessionUtil";
export default {
  name: "VIPIndex",
  computed: {
    SessionUtil() {
      return SessionUtil;
    }
  },
  components: {
    NavBar
  },
  setup() {
    const title = ref("会员中心");
    const isScrollLeft = ref(true);
    const months = ref(1);
    return {
      title,
      isScrollLeft,
      months
    };
  },
  mounted() {
    const that = this;
    this.$refs.choose.addEventListener("scroll", function () {
      if (that.$refs.choose.scrollWidth - that.$refs.choose.clientWidth - that.$refs.choose.scrollLeft <= 120) {
        that.isScrollLeft = false;
      } else {
        that.isScrollLeft = true;
      }
    });
  },
  methods: {
    chooseDuration(months, item) {
      this.months = months;
    }
  }
};